<div class="page-content">
	<div class="card">
		<div class="left-col">
			<div class="left-col__content">
				<img
					src="/assets/images/closer-logo.svg"
					alt="Closer"
					class="closer-logo"
				/>
				<h1 class="heading--1">Change is on the way.</h1>
				<h2 class="heading--2">
					Let’s unite around software built for your needs - at a fair price.
					Introducing Closer.
				</h2>
				<p>Sign up for product updates and release announcements.</p>

				<form [formGroup]="emailForm" name="form" class="form">
					<label for="email" class="label">Email address</label>
					<div class="input-wrapper input--one-field">
						<input
							type="email"
							name="email"
							id="email"
							class="input"
							formControlName="email"
						/>
						<input
							type="submit"
							value="Submit"
							class="button"
							(click)="registerInterest()"
						/>
					</div>

					<div
						class="errors input__feedback"
						*ngIf="email.touched && email.invalid"
					>
						<span *ngIf="email.errors.required">Email address required</span>
						<span *ngIf="email.errors.email">Please enter a valid email</span>
					</div>

					<div *ngIf="successful" class="input__feedback">
						We've received your email address. Thanks!
					</div>
				</form>

				<p class="legal-text muted--color muted--text">
					By submitting your email address, you consent to future communications
					from LawLabs. You can unsubscribe at any time.
				</p>
			</div>
		</div>

		<div class="right-col">
			<img
				src="/assets/images/file-management-ui.jpg"
				alt="Closer's file management interface. It's clean and well organized."
				class="ui-image"
			/>
		</div>
	</div>

	<footer class="footer">
		<p class="made-by">
			<img src="/assets/images/maple-leaf.svg" alt="" class="maple-leaf-icon" />
			Made in Ontario
		</p>

		<div class="footer__right-side">
			<p>&copy; Copyright 2021 LawLabs Inc.</p>
			<a emailLinkInterceptor href="mailto:keegan@lawlabs.ca">Contact</a>
		</div>
	</footer>
</div>
